export class ReturnLocationForm {
  returnLocations: IReturnLocationForm[] = [new ReturnLocation()];
}

export interface IReturnLocation {
  returnProductLocationId: string;
  address: string;
  city: string;
  state: string;
  isRemoved: boolean;
}

export interface IReturnLocationForm {
  address: string;
  state: string;
  city: string;
}

export class ReturnLocation {
  address: string = "";
  state: string = "";
  city: string = "";
}
export class ReturnLocationUpdateForm {
  returnProductLocationId: string ="";
  address: string = "";
  state: string = "";
  city: string = "";
}

export interface IReturnLocationsResponse {
  data: IReturnLocation[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}
export interface IReturnLocationResponse {
  data: IReturnLocation;
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}

export class StateForm {
  stateId: string = "";
  state: string = "";
}
export class RegionForm {
  regionId: string = "";
  region: string = "";
}

export class ShippingLocationPriceForm {
  stateList: StateForm[] = [];
  regionList: RegionForm[] = [];
  shippingPriceList: IShippingPriceForm[] = [];
}
export interface IShippingLocationPriceForm {
  stateList: StateForm[];
  regionList: RegionForm[];
  shippingPriceList: IShippingPriceForm[];
}
export interface IShippingPriceForm {
  shippingPriceId: string;
  region: string;
  state: string;
  fiveKgPrice: number;
  tenKgPrice: number;
  twentyFiveKgPrice: number;
  aboveKgPrice: number;
  status: string;
}
export class ShippingPriceForm {
  shippingPriceId: string = "";
  region: string = "";
  state: string = "";
  fiveKgPrice: number = 0;
  tenKgPrice: number = 0;
  twentyFiveKgPrice: number = 0;
  aboveKgPrice: number = 0;
  status: string = "";
}
export enum ShippingPriceStatus {
  false = "0",
  true = "1",
}
export interface IShippingPrice {
  vendorShippingPriceId: string;
  region: string;
  state: string;
  fiveKgPrice: number;
  tenKgPrice: number;
  twentyFiveKgPrice: number;
  aboveKgPrice: number;
  status: boolean;
}
export interface IShippingPriceResponse {
  data: IShippingPrice[];
  responseCode: string;
  responseMessage: string;
  isSuccessful: boolean;
}
export class RegionPriceForm {
  firstRegionPrice: number = 0;
  secondRegionPrice: number = 0;
  thirdRegionPrice: number = 0;
  fourthRegionPrice: number = 0;
  regionList: RegionForm[] = [];
}
export class StatePriceForm {
  firstStatePrice: number = 0;
  secondStatePrice: number = 0;
  thirdStatePrice: number = 0;
  fourthStatePrice: number = 0;
  stateList: StateForm[] = [];
}
